"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualMotorRenewalCarDetailsWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var FalconAccordion_1 = require("../../../../../components/FalconAccordion");
var commonFunctions_1 = require("../../../../../commonFunctions");
var core_1 = require("@athena-portal/core");
var ExcessExplainedRenderers_1 = require("../../../../../components/modals/renderers/ExcessExplainedRenderers");
var InfoModal_1 = require("../../../../../components/modals/InfoModal");
var AnnualMotorGlassAndRepairExcessWordingGenerator_1 = require("../../../../../helpers/annual/motor/AnnualMotorGlassAndRepairExcessWordingGenerator");
var services_1 = require("@falcon/services");
var AnnualMotorRenewalCarDetailsWidget = exports.AnnualMotorRenewalCarDetailsWidget = /** @class */ (function (_super) {
    __extends(AnnualMotorRenewalCarDetailsWidget, _super);
    function AnnualMotorRenewalCarDetailsWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.renderVoluntaryExcessValues = function (voluntaryExcess) {
            var elements = [];
            for (var index = 0; index <= 500; index += 50) {
                elements.push(React.createElement("option", { selected: voluntaryExcess === index, value: index },
                    "\u00A3",
                    index));
            }
            return elements;
        };
        _this.handleSelectOnChangeEvent = function (event) {
            var voluntaryExcess = parseInt(event.target.value, 10);
            var totalExcess = _this.state.compulsoryExcess + voluntaryExcess;
            _this.setState({
                voluntaryExcess: voluntaryExcess,
                totalExcess: totalExcess
            });
            _this.props.onStateChange("vehicles[0].annualVehicleExcess.voluntaryExcess", voluntaryExcess);
            _this.executeNativeEvent(event);
        };
        var compulsoryExcess = _this.props.interaction.vehicles[0].annualVehicleExcess.compulsoryExcess;
        var voluntaryExcess = _this.props.interaction.vehicles[0].annualVehicleExcess.voluntaryExcess;
        var totalExcess = compulsoryExcess + voluntaryExcess;
        _this.state = {
            lookup: [],
            compulsoryExcess: compulsoryExcess,
            voluntaryExcess: voluntaryExcess,
            totalExcess: totalExcess
        };
        return _this;
    }
    AnnualMotorRenewalCarDetailsWidget.prototype.componentDidMount = function () {
        this.fetchLookupValues("vehicleTransmission");
        this.fetchLookupValues("vehicleFuelType");
        this.fetchLookupValues("claimType");
        this.fetchLookupValues("mileage");
        this.fetchLookupValues("carUsage");
        this.fetchLookupValues("ncdEarnType");
    };
    AnnualMotorRenewalCarDetailsWidget.prototype.render = function () {
        var isAccordionOpen = this.props.interaction.uistate.referrerMtaJourney === services_1.INTERACTION_PROCESS_RENEWAL_CANCELLATION;
        return (React.createElement("div", { className: "section-panel text-center annual-motor-renewal car-details-section" },
            React.createElement("div", { className: "mt-3 panel-detail-output-entity" },
                React.createElement(FalconAccordion_1.FalconAccordion, { isOpen: isAccordionOpen, togglePositionTop: true, toggleHidden: React.createElement("div", { className: "toggle d-flex justify-content-between align-items-center" },
                        React.createElement("span", null),
                        React.createElement("span", { className: "font-weight-bold text-center fs-18 toggle-title collapsed-title" }, "Car details"),
                        React.createElement("span", { className: "toggle-icon expand-icon" })), toggleShown: React.createElement("div", { className: "toggle toggle-show d-flex justify-content-between align-items-center" },
                        React.createElement("span", null),
                        React.createElement("span", { className: "font-weight-bold text-center fs-18 toggle-title" }, "Car details"),
                        React.createElement("span", { className: "toggle-icon collapse-icon" })) }, this.renderCarsDetails(this.props.interaction)))));
    };
    AnnualMotorRenewalCarDetailsWidget.prototype.renderCarsDetails = function (interaction) {
        var _this = this;
        var vehicles = interaction.vehicles;
        return vehicles.map(function (vehicle, index) { return (React.createElement("div", { key: index, className: "summary-contents margin-bottom-24 padding-bottom-16" },
            React.createElement("div", { className: "renewal-accordion-content accordion-content grid-make-2-col icon-car-before" },
                React.createElement("div", { className: "detail display-block vehicle-detail" },
                    vehicle.registrationNumber &&
                        React.createElement("div", { className: "detail-key" }, "".concat(vehicle.make, ", ").concat(vehicle.model),
                            React.createElement("div", { className: "number-plate-preview" }, vehicle.registrationNumber)),
                    !vehicle.registrationNumber &&
                        React.createElement("div", { className: "detail-key" }, "".concat(vehicle.make, ", ").concat(vehicle.model, " "),
                            React.createElement("span", null,
                                "(",
                                React.createElement("span", { className: "text-danger" }, "no registration number"),
                                ")")),
                    React.createElement("div", { className: "detail-value font-weight-extra-light" }, "".concat((0, commonFunctions_1.getVehicleEngineSize)(vehicle), " ").concat((0, commonFunctions_1.getVehicleNumberOfDoors)(vehicle), " ").concat(vehicle.year, ", ").concat(_this.resolveLookupValue("vehicleTransmission", vehicle.transmission), ", ").concat(_this.resolveLookupValue("vehicleFuelType", (0, commonFunctions_1.getInteractionVehicleFuelType)(vehicle.fuelType, vehicle.fuelTypeFull)), " ").concat(vehicle.trackerInstalled ? ", Tracking device fitted" : "")),
                    React.createElement("div", { className: "detail-value font-weight-extra-light" }, "Manufactured in ".concat(vehicle.year)),
                    React.createElement("div", { className: "detail-value font-weight-extra-light" }, "Purchased in ".concat((0, commonFunctions_1.convertDate)(vehicle.purchaseDate, "MMM YYYY")))),
                React.createElement("div", { className: "detail" },
                    React.createElement("div", { className: "detail-key" }, "Annual mileage:"),
                    React.createElement("div", { className: "detail-value font-weight-extra-light" }, "".concat(_this.resolveLookupValue("mileage", vehicle.mileage.toString())))),
                React.createElement("div", { className: "detail" },
                    React.createElement("div", { className: "detail-key" }, "Postcode where the car is kept:"),
                    React.createElement("div", { className: "detail-value font-weight-extra-light" }, "".concat(vehicle.overnightLocationPostcode))),
                React.createElement("div", { className: "detail" },
                    React.createElement("div", { className: "detail-key" }, "Car usage:"),
                    React.createElement("div", { className: "detail-value font-weight-extra-light" }, "".concat(_this.fetchLookupValue("carUsage", vehicle.classOfUse)))),
                React.createElement("div", { className: "detail" },
                    React.createElement("div", { className: "detail-key" }, "Main driver:"),
                    React.createElement("div", { className: "detail-value font-weight-extra-light" }, _this.getMainDriverFullName(vehicle))),
                vehicle.policyHolderIsLegalOwner && (React.createElement("div", { className: "detail" },
                    React.createElement("div", { className: "detail-key" }, "Registered keeper and legal owner:"),
                    React.createElement("div", { className: "detail-value font-weight-extra-light" },
                        interaction.policyHolder.firstName,
                        " ",
                        interaction.policyHolder.lastName))),
                !vehicle.policyHolderIsLegalOwner && (React.createElement("div", { className: "detail" },
                    React.createElement("div", { className: "detail-key" }, "Registered keeper:"),
                    React.createElement("div", { className: "detail-value font-weight-extra-light" }, _this.getRegisteredKeeperOrLegalOwnerWording(vehicle.registeredKeeperId)))),
                !vehicle.policyHolderIsLegalOwner && (React.createElement("div", { className: "detail" },
                    React.createElement("div", { className: "detail-key" }, "Legal owner:"),
                    React.createElement("div", { className: "detail-value font-weight-extra-light" }, _this.getRegisteredKeeperOrLegalOwnerWording(vehicle.legalOwnerId)))),
                React.createElement("div", { className: "detail excess-detail" },
                    React.createElement("h2", { className: "detail-key excess-heading d-flex" },
                        "Excesses that apply",
                        React.createElement(InfoModal_1.InfoModal, { className: "mb-2 ml-2", title: "Excess explained", showArrow: false }, (0, ExcessExplainedRenderers_1.renderWolfExcessExplained)(vehicle.annualVehicleExcess))),
                    React.createElement("p", { className: "select-excess" }, "Please select your voluntary excess below."),
                    React.createElement("div", { className: "excess-picker" }, _this.renderExcessesPicker()),
                    React.createElement("p", { className: "selected-excess-info pb-3" },
                        "Your voluntary excess is added to the compulsory excess to give you the total amount you\u2019ll have to pay towards ",
                        React.createElement("span", { className: "font-weight-bold" }, "any claim"),
                        " you make involving accidental damage, fire and theft (but ",
                        React.createElement("span", { className: "font-weight-bold" }, "not"),
                        " glass-only claims)."),
                    React.createElement("p", { className: "selected-excess-info pb-3" }, "Your total excess applies every time you claim and to every car you\u2019re claiming on."),
                    AnnualMotorGlassAndRepairExcessWordingGenerator_1.AnnualMotorGlassAndRepairExcessWordingGenerator.getGlassAndRepairExcessWording(vehicle)),
                React.createElement("div", { className: "detail" },
                    React.createElement("div", { className: "justify-content-center", id: "edit-car-".concat(index), onClick: function () { return _this.navigateToEditCar(index); } },
                        React.createElement("button", { type: "button", className: "edit-car-btn btn btn-primary btn-add mt-1 mb-1" }, "Edit this car"))),
                React.createElement("div", { className: "detail display-block" },
                    React.createElement("div", { className: "new-quote-wording" }, "or get a new quote to replace it"),
                    React.createElement("div", { className: "justify-content-center", id: "replace-car-".concat(index), onClick: function () { return _this.navigateToReplaceCar(); } },
                        React.createElement("button", { type: "button", className: "replace-car-btn btn btn-white mt-1 mb-1" }, "Change this car")))))); });
    };
    AnnualMotorRenewalCarDetailsWidget.prototype.renderExcessesPicker = function () {
        var vehicle = this.props.interaction.vehicles[0];
        var compulsoryExcess = vehicle.annualVehicleExcess.compulsoryExcess;
        var voluntaryExcess = vehicle.annualVehicleExcess.voluntaryExcess;
        var totalExcess = compulsoryExcess + voluntaryExcess;
        return (React.createElement("div", null,
            React.createElement("div", { className: "voluntary-excess-picker" },
                React.createElement("div", null,
                    React.createElement("div", { className: "voluntary-excess-picker__title" },
                        React.createElement("div", null, "Compulsory"),
                        React.createElement("div", null, "excess")),
                    React.createElement("div", { className: "voluntary-excess-picker__value" },
                        "\u00A3",
                        compulsoryExcess)),
                React.createElement("div", { className: "voluntary-excess-picker__operation" }, "+"),
                React.createElement("div", null,
                    React.createElement("div", { className: "voluntary-excess-picker__title" },
                        React.createElement("div", null, "Voluntary"),
                        React.createElement("div", null, "excess")),
                    React.createElement("div", { className: "input-group" },
                        React.createElement("select", { id: this.props.question.name, className: "form-control voluntary-excess-picker__dropdown", onChange: this.handleSelectOnChangeEvent, onFocus: this.executeNativeEvent, onClick: this.executeNativeEvent, onDoubleClick: this.executeNativeEvent }, this.renderVoluntaryExcessValues(voluntaryExcess)))),
                React.createElement("div", { className: "voluntary-excess-picker__operation" }, "="),
                React.createElement("div", null,
                    React.createElement("div", { className: "voluntary-excess-picker__title" },
                        React.createElement("div", null, "TOTAL"),
                        React.createElement("div", null, "excess")),
                    React.createElement("div", { className: "voluntary-excess-picker__value total-excess" },
                        "\u00A3",
                        totalExcess)))));
    };
    AnnualMotorRenewalCarDetailsWidget.prototype.fetchLookupValue = function (fieldId, id) {
        var value = "";
        this.lookupService.fetchLookupValues(fieldId, "en-UK").subscribe(function (lookupValues) {
            var _a, _b;
            value = (_b = (_a = lookupValues === null || lookupValues === void 0 ? void 0 : lookupValues.find(function (entry) { return entry.id === id; })) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "";
        });
        return value;
    };
    AnnualMotorRenewalCarDetailsWidget.prototype.getMainDriverFullName = function (vehicle) {
        var allDrivers = [this.props.interaction.policyHolder].concat(this.props.interaction.additionalDrivers || []);
        var mainDriver = allDrivers.find(function (driver) { return vehicle.mainDriverId === driver.personId; });
        return (mainDriver === null || mainDriver === void 0 ? void 0 : mainDriver.firstName) + ' ' + (mainDriver === null || mainDriver === void 0 ? void 0 : mainDriver.lastName);
    };
    AnnualMotorRenewalCarDetailsWidget.prototype.fetchLookupValues = function (lookupName) {
        var _this = this;
        this.lookupService.fetchLookupValues(lookupName, "en-UK").subscribe(function (lookupValues) {
            _this.state.lookup[lookupName] = lookupValues;
            _this.setState({ lookup: _this.state.lookup });
        }, function () {
            throw new Error("Error: failed to fetch lookup values for '".concat(lookupName, "' lookup"));
        });
    };
    AnnualMotorRenewalCarDetailsWidget.prototype.navigateToEditCar = function (vehicleIndex) {
        if (vehicleIndex === 0) {
            this.props.engine.navigate("editCarEntryPage", false);
        }
        else {
            this.props.engine.navigate("additionalVehicle".concat(vehicleIndex, "DetailsPage"), false);
        }
    };
    AnnualMotorRenewalCarDetailsWidget.prototype.navigateToReplaceCar = function () {
        this.props.engine.navigate("replaceCarEntryPage", false);
    };
    AnnualMotorRenewalCarDetailsWidget.prototype.getRegisteredKeeperOrLegalOwnerWording = function (id) {
        var interaction = this.props.engine.getInteraction();
        var variants = new Map([
            [1, "Brother / Sister"],
            [2, "Child"],
            [3, "Common Law / Partner"],
            [4, "Company"],
            [5, "Lease Company"],
            [6, "Parent"],
            [7, "Other Relative"],
            [8, "Spouse / Civil Partner"],
            [9, "Other / Friend"]
        ]);
        if (Number(id) === 0) {
            return "".concat(interaction.policyHolder.firstName, " ").concat(interaction.policyHolder.lastName);
        }
        return variants.get(Number(id));
    };
    AnnualMotorRenewalCarDetailsWidget.prototype.resolveLookupValue = function (lookupName, lookupId) {
        if (!lookupId || !this.state.lookup || !this.state.lookup[lookupName]) {
            return "";
        }
        var listItem = this.state.lookup[lookupName].find(function (lItem) { return "".concat(lItem.id) === "".concat(lookupId); });
        if (!listItem) {
            throw new Error("Error: no item with id '".concat(lookupId, "' found in lookup '").concat(lookupName, "'"));
        }
        return listItem.value;
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.LookupService),
        __metadata("design:type", Object)
    ], AnnualMotorRenewalCarDetailsWidget.prototype, "lookupService", void 0);
    return AnnualMotorRenewalCarDetailsWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=AnnualMotorRenewaCarDetailsWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/renewal/car/AnnualMotorRenewaCarDetailsWidget.js
// module id = 3188
// module chunks = 0